import type { ReactElement } from 'react';

import type { DrupalParagraph } from '@commons/types/drupal';

import ImageParagraph from './Image';
import ImageTileParagraph from './ImageTile';
import NodeParagraph from './Node';
import RichTextParagraph from './RichText';
import TextImageParagraph from './TextImage';
import TexturedTileParagraph from './TexturedTile';

/**
 * Enum of all available paragraph bundles.
 *
 * Makes it easier to read and edit the bundles.
 */

export enum PARAGRAPH_BUNDLE {
  Node = 'content_reference',
  Image = 'media',
  RichText = 'rich_text',
  TextImage = 'text_image',
  TexturedTile = 'textured_tile',
  ImageTile = 'image_tile',
}

/**
 * Type definition for a paragraph component.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Paragraph = (props: DrupalParagraph & any) => ReactElement | null;

/**
 * Type definition for a paragraphs factory.
 *
 * It uses `string` instead of the enums as key, so that each site can have its own paragraphs without type issue.
 */

export type ParagraphsFactory = Record<string, Paragraph>;

/**
 * Factory of all available paragraphs.
 */

export const paragraphs: ParagraphsFactory = {
  [PARAGRAPH_BUNDLE.Node]: NodeParagraph,
  [PARAGRAPH_BUNDLE.Image]: ImageParagraph,
  [PARAGRAPH_BUNDLE.RichText]: RichTextParagraph,
  [PARAGRAPH_BUNDLE.TextImage]: TextImageParagraph,
  [PARAGRAPH_BUNDLE.TexturedTile]: TexturedTileParagraph,
  [PARAGRAPH_BUNDLE.ImageTile]: ImageTileParagraph,
};
